import { FollowedPropertyRelationship } from './graphql-schema.generated';
var relationships = [{
  value: FollowedPropertyRelationship.OWNER,
  label: 'I own and live in this property'
}, {
  value: FollowedPropertyRelationship.LANDLORD,
  label: 'I’m the owner of this property'
}, {
  value: FollowedPropertyRelationship.TENANT,
  label: 'I’m renting this property'
}, {
  value: FollowedPropertyRelationship.CURIOUS,
  label: 'I’m curious about properties like this'
}];
export default relationships;